import React from "react";
import SaveTheDate from "./SaveTheDate";

export default function Home() {
    return (<SaveTheDate/>);
}